export default "__VITE_ASSET__DDqKhhUL__"